import { ValidationError, Validator } from '@tt4b/ttam-hooks';
import { computed, ComputedRef, toRefs } from '@vue/composition-api';
import { i18n } from './../../../../i18n';
import { DestinationUrlType, ParamsTypesEnum, DeepLinkType } from '@tt4b/ttam-enums';

const getValueOverHint = (): ValidationError =>
  new ValidationError({
    message: i18n.t('creative_utm_value_over_hint'),
    messageI18nKey: 'creative_utm_value_over_hint',
  });

const getInputEmpty = (): ValidationError =>
  new ValidationError({
    message: i18n.t('creative_utm_input_empty'),
    messageI18nKey: 'creative_utm_input_empty',
  });

const getFieldOverHint = (): ValidationError =>
  new ValidationError({
    message: i18n.t('creative_utm_field_over_hint'),
    messageI18nKey: 'creative_utm_field_over_hint',
  });

export function useValidate() {
  const FIELD_LIMIT = 100;
  const VALUE_LIMIT = 600;

  const utmValueValidator: ComputedRef<Validator> = computed(() => [
    {
      validator: (_rule, _value, callback) => {
        if (_value.trim().length > VALUE_LIMIT) {
          return callback(getValueOverHint());
        }
        return callback();
      },
      trigger: 'blur',
    },
  ]);

  const customFieldValidator: ComputedRef<Validator> = computed(() => [
    {
      validator: (_rule, _value, callback) => {
        if (!_value.trim()) {
          return callback(getInputEmpty());
        }
        if (_value.trim().length > FIELD_LIMIT) {
          return callback(getFieldOverHint());
        }
        return callback();
      },
      trigger: 'blur',
    },
  ]);

  const customValueValidator: ComputedRef<Validator> = computed(() => [
    {
      validator: (_rule, _value, callback) => {
        if (!_value.trim()) {
          return callback(getInputEmpty());
        }
        if (_value.trim().length > VALUE_LIMIT) {
          return callback(getValueOverHint());
        }
        return callback();
      },
      trigger: 'blur',
    },
  ]);

  return {
    utmValueValidator,
    customFieldValidator,
    customValueValidator,
  };
}

export function useFooterShow(props) {
  const { isDlp, urlType, paramsType, isOpenUrl, isVsa, isEntryNewUI } = toRefs(props);
  const currentParamTypeEnum = isOpenUrl.value ? DeepLinkType : ParamsTypesEnum;
  const showCustomLink = computed(
    () =>
      isDlp.value ||
      urlType.value === DestinationUrlType.instantPage ||
      paramsType.value === currentParamTypeEnum.CustomeLink ||
      !isVsa.value, // Non-VSA, always show Website link
  );
  const showProductLink = computed(() => {
    // If dynamic destination on, show both product and website link
    if (isEntryNewUI.value || isDlp.value || urlType.value === DestinationUrlType.instantPage) {
      return true;
    }

    if (isOpenUrl.value) {
      // For deeplink url, both type will show Product link
      return paramsType.value === DeepLinkType.ProductDeepLink || paramsType.value === DeepLinkType.CustomeLink;
      // For external url, only ProductDeepLink will show Product link
    } else {
      return paramsType.value === ParamsTypesEnum.ProductDeepLink;
    }
  });
  const showLabel = computed(() => showCustomLink.value && showProductLink.value);

  return {
    showLabel,
    showCustomLink,
    showProductLink,
  };
}
